// extracted by mini-css-extract-plugin
export default {"statusHover":"h5YYBAo4W_O9u9XajY4S"};